export const SCROLL_TO_ENROLLMENT_FORM = 'enrollment-form';
export const SCROLL_TO_PAYMENT_TABLE = 'payment-table';
